angular.module('zc')
  .component('zcIwStartedRate', {
    templateUrl: '/templates/projects.iw/iw_started_rate.html',
    bindings: {
      project: '<',
      filters: '<'
    },
    controller: zcIwStartedRateController
  });

zcIwStartedRateController.$inject = ['$scope', '$filter', '$window', 'InterestWidgetStats', 'ChartV2', 'lineChartV2Config', 'lib'];
function zcIwStartedRateController($scope, $filter, $window, InterestWidgetStats, ChartV2, lineChartV2Config, lib) {
  const vm = this;

  const chart = new ChartV2(lineChartV2Config, {
    yAxis: [{
      title: { text: null },
      min: 0,
      labels: {
        formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 0)} ${$filter('translate')('sharedModules.common.unit.session')}` }
      },
    }, {
      opposite: true,
      title: { text: null },
      min: 0,
      labels: {
        formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 2)} %` }
      }
    }]
  });
  vm.chartConfig = chart.getConfig();

  vm.$onInit = () => {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters)
      .then(stats => {
        vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
        const iwStartedStats = [];
        const iwStartedRateStats = [];
        stats.forEach(stat => {
          stat = InterestWidgetStats.transform(stat);
          iwStartedStats.push([stat.start_at.valueOf(), stat.iw_started.session_count]);
          iwStartedRateStats.push([stat.start_at.valueOf(), stat.iw_started_rate]);
        });
        chart.resetSeries();
        chart.addSeries({
          type: 'column',
          name: $filter('translate')('projectsIw.startedRate.deliverySessionCount'),
          data: iwStartedStats,
          tooltip: {
            valueSuffix: $filter('translate')('projectsIw.startedRate.session'),
            valueDecimals: 0
          },
          yAxis: 0
        });
        chart.addSeries({
          type: 'line',
          name: $filter('translate')('projectsIw.startedRate.deliveryRate'),
          data: iwStartedRateStats,
          tooltip: {
            valueSuffix: '%',
            valueDecimals: 1
          },
          yAxis: 1
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.iw/iw_started_rate.js